import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Component({
  selector: 'app-auth-alert',
  templateUrl: './auth-alert.component.html',
  styleUrls: ['./auth-alert.component.css']
})
export class AuthAlertComponent implements OnInit {

  module: any = "";
  environmentSettings: any;
  dashboardURL: any;
  meetingURL: any;
  switchingCompanyID: any;
  private sub: any;


  constructor(private router: Router,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    $("#unAuthAccess").hide();
    $("#switchCompanyPage").hide();
    this.environmentSettings = environment;
    if (this.environmentSettings.PSS) {
      this.dashboardURL = 'dashboards/director-view';
    } else {
      this.dashboardURL = environment.govEvaUIBaseUrl + 'structure/(structure-outlet:dashboards/director-view)';
    }
    this.sub = this.activeRoute.params.subscribe(params => {
      // console.log('PARAMSMSMSMSMSMSMSMS',params);
      this.module = params['moduleName']; // (+) converts string 'id' to a number
      this.switchingCompanyID = params['companyID'];
      this.meetingURL = 'meeting/edit/' + params['meetingID'] + '/' + params['companyID'];
      if (this.module == null || this.module == undefined) {
        $("#unAuthAccess").show();
      } else {
        $("#switchCompanyPage").show();
      }
      // this.switchcompany()
      // In a real app: dispatch action to load the details here.
    });
  }

  //Check On Edit of Each Module---
  validateModuleWithPermissions(element, ID, companyID, urlFor) {
    console.log('element===>', element, ID, companyID)
    if(!environment.PSS){
      switch (element) {
        //Meeting
        case 'Meeting': {
          // console.log(element);
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSMeetingUpdateURL : environment.UrlData.PSSMeetingListURL);
          if (this.isHavingAccessOfModule('Meeting', reqUrl)) {
            //Rout to accessing Module
            this.router.navigate(['/meeting', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
  
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/meeting', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          }
          break;
        }
  
        //Director
        case 'Director': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSUserUpdateURL : environment.UrlData.PSSUserListURL);
          if (this.isHavingAccessOfModule('UserMaster', reqUrl)) {
            window.open(environment.govEvaUIBaseUrl + environment.UrlData.GovEvaUserList, "_self")
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            window.open(environment.govEvaUIBaseUrl + environment.UrlData.GovEvaUserList, "_self")
          }
          break;
        }
  
        //KMP
        case 'KMP': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSUserUpdateURL : environment.UrlData.PSSUserListURL);
          if (this.isHavingAccessOfModule('UserMaster', reqUrl)) {
            window.open(environment.govEvaUIBaseUrl + environment.UrlData.GovEvaUserList, "_self")
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            window.open(environment.govEvaUIBaseUrl + environment.UrlData.GovEvaUserList, "_self")
          }
          break;
        }
  
        // Finance
        case 'Finance': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSFinanceUpdateURL : environment.UrlData.PSSFinanceListURL);
          if (this.isHavingAccessOfModule('Finance', reqUrl)) {
            // window.open(environment.govEvacompnayBaseUrl +  environment.UrlData.GovEvaUserList, "_self")
            this.router.navigate(['/company/financeDetails', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/company/financeDetails', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          }
          break;
        }
  
        // Tag
        case 'Tag': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSTagURL : environment.UrlData.PSSTagURL);
          if (this.isHavingAccessOfModule('Tag', reqUrl)) {
            this.router.navigate(['/group', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/group', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // LibraryTask
        case 'LibraryTask': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSLibraryTaskUpdateURL : environment.UrlData.PSSLibraryTaskListURL);
          if (this.isHavingAccessOfModule('LibraryTask', reqUrl)) {
            this.router.navigate(['/tasks/library', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/tasks/library', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // ActivatedTask
        case 'ActivatedTask': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSActivatedTaskUpdateURL : environment.UrlData.PSSActivatedTaskListURL);
          if (this.isHavingAccessOfModule('ActivatedTask', reqUrl) || this.isHavingAccessOfModule('ActivatedTaskAll', reqUrl) || this.isHavingAccessOfModule('ActivatedTaskIndividual', reqUrl)) {
            this.router.navigate(['/tasks/activated', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/tasks/activated', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // LibraryProcess
        case 'LibraryProcess': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSLibraryProcessUpdateURL : environment.UrlData.PSSLibraryProcessListURL);
          if (this.isHavingAccessOfModule('Process', reqUrl)) {
            this.router.navigate(['/process', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/process', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // ActivatedProcess
        case 'ActivatedProcess': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSActivatedProcessShowURL : environment.UrlData.PSSActivatedProcessListURL);
          if (this.isHavingAccessOfModule('ActivatedProcessTasks', reqUrl)) {
            this.router.navigate(['/activatedprocess', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/activatedprocess', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // Category
        case 'Category': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSCategoryURL : environment.UrlData.PSSCategoryURL);
          if (this.isHavingAccessOfModule('Category', reqUrl)) {
            this.router.navigate(['/category', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/category', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // Committee
        case 'Committee': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSCommitteeUpdateURL : environment.UrlData.PSSCommitteeListURL);
          if (this.isHavingAccessOfModule('Committee', reqUrl)) {
            this.router.navigate(['/committee', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/committee', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // Agenda
        case 'Agenda': {
          // console.log('HAS ACCESSS++++++>>>', this.isHavingAccessOfModule('Agenda', reqUrl));
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSAgendaUpdateURL : environment.UrlData.PSSAgendaListURL);
          if (this.isHavingAccessOfModule('Agenda', reqUrl)) {
            this.router.navigate(['/agenda', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/agenda', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // DocumentManagement
        case 'DocumentManagement': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSDocumentListURL : environment.UrlData.PSSDocumentListURL);
          if (this.isHavingAccessOfModule('DocumentManagement', reqUrl)) {
            this.router.navigate(['/documentManagement', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/documentManagement', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // DocumentType
        case 'DocumentType': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSDocumentTypeListURL : environment.UrlData.PSSDocumentTypeListURL);
          if (this.isHavingAccessOfModule('DocumentType', reqUrl)) {
            this.router.navigate(['/documentType', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/documentType', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        // Holiday
        case 'Holiday': {
          var reqUrl = (urlFor === 'edit' ? environment.UrlData.PSSHolidayListURL : environment.UrlData.PSSHolidayListURL);
          if (this.isHavingAccessOfModule('Holiday', reqUrl)) {
            this.router.navigate(['/holiday', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);
          } else {
            // this.router.navigate(['/authAlert', { 'moduleName': element, 'ID': ID, 'companyID': companyID }]);
            this.router.navigate(['/holiday', { 'moduleName': element, 'meetingID': ID, 'companyID': companyID }]);

          }
          break;
        }
  
        default: {
          break;
        }
      }
    }
    

  }

  // switchcompany() {
  //   let uniqueUserId = JSON.parse(localStorage.getItem('user')).UniqueUserId;
  //   // console.log("url",environment.govEvacompnayBaseUrl + 'structure/(structure-outlet:dashboards/alpha/)?CompanyId='+companyid+'&UniqueUserId='+uniqueUserId);
  //   window.open(environment.govEvacompnayBaseUrl + 'structure/(structure-outlet:dashboards/alpha)?CompanyId=' + this.switchingCompanyID + '&UniqueUserId=' + uniqueUserId +'&returnURL='+this.meetingURL, "_self")
  // }

  // closeWindow(){
  //   window.close();
  // }


  isHavingAccessOfModule(module, Url): boolean {

    var returningValue = false;
    // if (environment.PSS == false) {
    const resourcesValue = JSON.parse(localStorage.getItem('resources'));
    _.forEach(resourcesValue, function (data) {
      if (data.Menu == module) {
        for (var i = 0; i < _.size(data.ChildResources); i++) {
          var childrenData = data.ChildResources[i];
          if (childrenData.Url.includes(Url)) {
            returningValue = true;
          }
        }
      }
    });
    return returningValue;

    // } else {
    //   return true;
    // }
  }

}
